module.exports = __webpack_public_path__ + "img/@logo_kbinsure.13d46389.png";